import React from 'react';
import cn from './../../lib/bem/index';
import ico_loading from './../../assets/svg/ico_loading.gif';

import './loading_component.scss';

const LoadingComponent = () => {

    const classes = cn("loadingComponent");

    return (
        <div className={classes()}> 
            <img src={ico_loading} alt='cargando' />        
        </div>
    );
}

export default LoadingComponent;